export default __webpack_public_path__ + "static/media/CI.38f228a7.png";